/***************************************************************************

    SocialMenuComponent.tsx
    -------------------------
    last Update          : August 12, 2025
    by                   : quentin.savoye@cil4sys.com
    copyright            : (C) 2025 by CIL4Sys Engineering 

***************************************************************************/

import React from "react"
import { Nav } from "react-bootstrap"
import { FaLinkedin, FaXTwitter, FaYoutube } from "react-icons/fa6"

interface Props {
	network: "youtube" | "x" | "linkedin"
	link: string
}

class SocialMenuClassComponent extends React.Component<Props> {
	constructor(aProps: Props) {
		super(aProps)
	}

	public override render(): React.ReactNode {
		return (
			<Nav.Link className="our-networks" href={this.props.link} target="_blank" rel="noreferrer">
				{this.props.network == "youtube" && <FaYoutube style={{ verticalAlign: "baseline" }} />}
				{this.props.network == "x" && <FaXTwitter style={{ verticalAlign: "baseline" }} />}
				{this.props.network == "linkedin" && <FaLinkedin style={{ verticalAlign: "baseline" }} />}
			</Nav.Link>
		)
	}
}

export default SocialMenuClassComponent
